// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__bUJ0j","name":"Header_name__WKpvJ","birthday":"Header_birthday__1t5R1","skeleton":"Header_skeleton__3yepE"};